/**
 * Render a compact rank label for a university card / hero.
 *
 * Feb 2026 · Task 5 · Rank coverage cleanup.
 *
 * Preference order (most-relevant-first):
 *   1. `uk_rank`     → "UK #12"   (Complete University Guide 2025)
 *   2. `world_rank`  → "World #85" (QS World University Rankings)
 *   3. `world_rank_band` → "Ranked 1001+" (QS bracket)
 *   4. nothing (empty string)
 *
 * UK-domestic rank leads because that's what UK families actually
 * shop against; world rank comes second for international families;
 * the QS band is a truthful last-resort so families understand the
 * uni IS ranked, just deep in the tail.
 */
export function rankLabel(uni) {
  if (!uni) return "";
  if (Number.isInteger(uni.uk_rank) && uni.uk_rank > 0)
    return `UK #${uni.uk_rank}`;
  if (Number.isInteger(uni.world_rank) && uni.world_rank > 0)
    return `World #${uni.world_rank}`;
  if (typeof uni.world_rank_band === "string" && uni.world_rank_band)
    return `Ranked ${uni.world_rank_band}`;
  return "";
}
